import React from 'react'

const STAGE_LABELS: Record<string, string> = {
  STAKE: 'Stake', LEND: 'Lend', BORROW: 'Borrow', LP: 'LP', HEDGE: 'Hedge', LOOP: 'Loop',
}

interface Props {
  stepIndex: number
  stageKeys: string[]
  onStepClick: (i: number) => void
  /** Furthest step that may be opened; later ones need a plan for the chosen amount. */
  maxStep: number
}

export function WizardProgressBar({ stepIndex, stageKeys, onStepClick, maxStep }: Props) {
  const labels = ['Strategy', 'Swap', ...stageKeys.map(k => STAGE_LABELS[k] ?? k), 'Done']

  return (
    <div className="flex items-start gap-0 mb-6">
      {labels.map((label, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <div
              className={`flex-1 h-px mt-[13px] transition-colors ${
                i <= stepIndex ? 'bg-accent-purple/60' : 'bg-white/10'
              }`}
            />
          )}
          <button
            type="button"
            onClick={() => onStepClick(i)}
            disabled={i > maxStep}
            aria-label={i > maxStep ? `${label} — available once your plan for this amount is ready` : undefined}
            title={i > maxStep ? 'Available once your plan for this amount is ready' : undefined}
            className="flex flex-col items-center gap-1 shrink-0 disabled:cursor-not-allowed disabled:opacity-50"
            aria-current={i === stepIndex ? 'step' : undefined}
          >
            <span
              className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-200 ${
                i < stepIndex
                  ? 'bg-accent-purple text-white'
                  : i === stepIndex
                  ? 'ring-2 ring-accent-purple ring-offset-1 ring-offset-surface bg-accent-purple/20 text-white'
                  : 'bg-white/5 text-gray-600'
              }`}
            >
              {i < stepIndex ? (
                <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="w-3 h-3">
                  <polyline points="1 6 5 10 11 2" />
                </svg>
              ) : (
                i + 1
              )}
            </span>
            <span
              className={`text-[9px] leading-none hidden sm:block transition-colors ${
                i === stepIndex ? 'text-white font-medium' : i < stepIndex ? 'text-accent-purple/70' : 'text-gray-600'
              }`}
            >
              {label}
            </span>
          </button>
        </React.Fragment>
      ))}
    </div>
  )
}
